import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from '@/reducers/rootReducer';
import { apiSlice } from '@/features/savedQueriesWidget/apiSlice';
import { publicDatasetApi } from '@/features/publicDatasets/publicDatasetApi';
import { queryColumnsApi } from '@/features/addWidgetModal/queryColumnsApi';
import { dashboardFiltersApi } from '@/features/addWidgetModal/filtersApi';
import { chartConfigMiddleware } from '@/features/publicDatasets/PublicChartConfigMiddleware';
import { creditsApi } from '@/features/credits/apiSlice';
import { inviteApi } from '@/features/dashboardShare/ShareDropdown/InviteTab/inviteApi';
import { rtkQueryErrorLogger, userActionsMiddleware } from '@/middlewares';
import { suggestionApi } from '@/features/suggestions/apiSlice';
import { permissionApi } from '@/permissions/permissionApi';
import { subscriptionManagementApi } from '@/features/subscrriptionmanagement/apiSlice';
import { subscriptionApi } from '@/features/subscription/apiSlice';
import { drilldownApi } from '@/features/drilldown/apiSlice';
import { datasourcesApi } from '@/features/datasources/apiSlice';
import { dashboardApi } from '@/features/dashboard/apiSlice';
import { chartConfigurationApi } from '@/features/chart-configuration/apiSlice';
import { queryConfigurationApi } from '@/features/queryMetricsDimensionsConfig/apiSlice';
import { queryBuilderQueriesApi } from '@/features/query-builder/queriesApiSlice';
import { queryBuilderSavedQueriesApi } from '@/features/query-builder/savedQueriesApiSlice';
import { fullQueryResultsApiSlice } from '@/features/query-builder/fullQueryResultsApiSlice';
import { categoriesApiSlice } from '@/features/categories/categoriesApiSlice';
import { zendeskApi } from '@/features/zendesk/apiSlice';
import { bucketFeedsApi } from '@/features/bucketFeeds/bucketFeedsApiSlice';
import { alertApi } from '@/features/alerts/alertApiSlice';
import { googleSheetsApi } from '@/features/google-sheets/googleSheetsApi';
import { zapierApiSlice } from '@/features/zapier/zapierApiSlice';
import { suggestedQueriesApiSlice } from '@/features/suggested-queries/suggestedQueriesApiSlice';
import { customerFacingDashboardApi } from '@/features/customer-facing-dashboards/apiSlice';
import { savedQueryFilterPresetsApi } from '@/features/saved-query-dashboard-filter-presets/apiSlice';

export const store = configureStore({
  // @ts-expect-error: Will be ok after we type the whole redux state.
  reducer: rootReducer,
  // @ts-expect-error: investigate and fix
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // TODO: remove this config once all of the utils class wrappers are removed!!!
      serializableCheck: false,
      immutableCheck: false,
    }).concat(
      userActionsMiddleware,
      chartConfigMiddleware,
      rtkQueryErrorLogger,
      datasourcesApi.middleware,
      apiSlice.middleware,
      publicDatasetApi.middleware,
      queryColumnsApi.middleware,
      dashboardFiltersApi.middleware,
      creditsApi.middleware,
      inviteApi.middleware,
      permissionApi.middleware,
      suggestionApi.middleware,
      subscriptionManagementApi.middleware,
      subscriptionApi.middleware,
      drilldownApi.middleware,
      dashboardApi.middleware,
      chartConfigurationApi.middleware,
      categoriesApiSlice.middleware,
      queryConfigurationApi.middleware,
      queryBuilderQueriesApi.middleware,
      queryBuilderSavedQueriesApi.middleware,
      fullQueryResultsApiSlice.middleware,
      bucketFeedsApi.middleware,
      alertApi.middleware,
      googleSheetsApi.middleware,
      suggestedQueriesApiSlice.middleware,
      savedQueryFilterPresetsApi.middleware,
      zapierApiSlice.middleware,
      zendeskApi.middleware,
      customerFacingDashboardApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
